<template xmlns:v-popover="">
  <el-card>
    <div class="card-content device-notes-tags">
      <!--NOTES-->
      <div class="note">
        <h2>Notes</h2>
        <el-alert
            v-if="fetchingNotes.error.value"
            title="Something went wrong"
            type="info"
            description="Try to reload this card"
            show-icon />
        <section
            v-loading="fetchingNotes.working"></section>
        <transition-group name="fade">
          <section
              v-for="nt in notes.comments"
              :key="nt.id">
            <p>{{ nt.content }}</p>
            <div class="foot-note">
              <div>
                <span>Added by</span>
                <span> {{ nt.user }} - </span>
                <span>{{ nt.created_at | moment('DD/MM/YY hh:mm A') }}</span>
                <i
                    :class="{ 'el-icon-loading': nt.id === note.removingId && note.working, 'el-icon-delete': nt.id !== note.removingId }"
                    @click="removeNote(nt.id)"></i>
              </div>
            </div>
            <br>
          </section>
        </transition-group>
        <div class="add-btn">
          <el-popover
              ref="postnote"
              v-model="note.visible"
              placement="right"
              width="444">
            <div class="new-note-text__textarea">
              <el-input
                  v-model="note.text"
                  size="medium"
                  type="textarea"
                  :disabled="note.working"
                  :rows="3"
                  placeholder="Write your note" />
            </div>
            <div style="text-align: right; margin: 0">
              <el-button
                  size="mini"
                  type="text"
                  @click="resetNote()">
                cancel
              </el-button>
              <el-button
                  :loading="note.working"
                  type="primary"
                  size="mini"
                  @click="postNote()">
                save
              </el-button>
            </div>
          </el-popover>
          <el-button
              v-popover:postnote
              type="text">
            + Add Note
          </el-button>
        </div>
      </div>
      <hr>
      <!--TAGS-->
      <div class="tags">
        <h2>Tags</h2>
        <el-alert
            v-if="fetchingTags.error.value"
            title="Something went wrong"
            type="info"
            description="Try to reload this card"
            show-icon />
        <section v-loading="fetchingTags.working">
          <el-tag
              v-for="(tag, index) in tags"
              :key="index"
              closable
              type="info"
              @close="deleteTag(tag.text)">
            {{ tag.text }}
          </el-tag>
        </section>
        <div class="add-btn">
          <el-popover
              ref="addtag"
              v-model="tag.visible"
              placement="right"
              width="444">
            <div class="new-note-text__textarea">
              <el-input
                  v-model="tag.text"
                  size="medium"
                  placeholder="Tag"
                  :disabled="tag.working"
                  @keyup.enter.native="addTag()" />
            </div>
            <div style="text-align: right; margin: 0">
              <el-button
                  size="mini"
                  type="text"
                  @click="resetTag()">
                cancel
              </el-button>
              <el-button
                  type="primary"
                  size="mini"
                  :loading="tag.working"
                  @click="addTag()">
                save
              </el-button>
            </div>
          </el-popover>
          <el-button
              v-popover:addtag
              type="text">
            + Add Tag
          </el-button>
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
import { remove } from "lodash";
import Vue from "vue";
import { createNamespacedHelpers as h } from "vuex";
const { mapActions } = h("db/account");

export default {
  name: "NotesTags",
  props: {
    macId: {
      type: String,
      default() {
        return null;
      },
      validator(id) {
        const macIdRegexp = /^([0-9A-Fa-f]{2}[:-]?){5}([0-9A-Fa-f]{2})$/;
        return id.match(macIdRegexp);
      },
    },
  },
  data() {
    return {
      fetchingTags: {
        working: false,
        error: {
          value: false,
          msg: "",
        },
      },
      fetchingNotes: {
        working: false,
        error: {
          value: false,
          msg: "",
        },
      },
      tag: {
        visible: false,
        working: false,
        text: "",
      },
      note: {
        visible: false,
        working: false,
        removingId: -1,
        error: {
          value: false,
          msg: "",
        },
        text: "",
      },
      tags: [],
      notes: {
        meta: { total: 0 },
        comments: [],
      },
    };
  },
  computed: {
    removeNoteIcon: {
      get(id) {
        return this.note.working && this.note.removingId === id
          ? "el-icon-loading"
          : "el-icon-delete";
      },
    },
  },
  created() {
    this.getNotes();
    this.getTags();
  },
  methods: {
    ...mapActions([
      "fetchNotes",
      "fetchTags",
      "addNote",
      "deleteNote",
      "updateTags",
    ]),
    clearNoteError() {
      this.note.error = {
        value: false,
        msg: "",
      };
    },
    clearTagError() {
      this.tag.error = {
        value: false,
        msg: "",
      };
    },
    resetTag() {
      this.tag = {
        visible: false,
        working: false,
        text: "",
        error: this.tag.error,
      };
    },
    resetNote() {
      this.note = {
        visible: false,
        working: false,
        text: "",
        removingId: -1,
        error: this.note.error,
      };
    },
    getNotes() {
      let self = this;
      this.fetchingNotes.working = true;
      this.fetchingNotes.error.value = false;
      this.fetchingNotes.error.msg = "";
      this.fetchNotes({ commentableId: this.macId })
        .then((notes) => {
          self.notes = notes;
        })
        .catch((error) => {
          if (error.status !== 404) {
            this.fetchingNotes.error.value = true;
            this.fetchingNotes.error.msg = error;
          }
        })
        .finally(() => (this.fetchingNotes.working = false));
    },
    getTags() {
      this.fetchingTags.working = true;
      this.fetchingTags.error.value = false;
      this.fetchingTags.error.msg = "";
      this.fetchTags({ taggableId: this.macId })
        .then((tags) => {
          this.tags = tags;
        })
        .catch((error) => {
          if (error.status !== 404) {
            this.fetchingTags.error.value = true;
            this.fetchingTags.error.msg = error;
          }
        })
        .finally(() => (this.fetchingTags.working = false));
    },
    postNote() {
      this.note.working = true;
      this.addNote({ commentableId: this.macId, note: this.note.text })
        .then((note) => {
          this.notes.comments.push(note);
          this.note.visible = false;
        })
        .catch(this.onError())
        .finally(() => this.resetNote());
    },
    removeNote(id) {
      this.note.working = true;
      this.note.removingId = id;
      this.deleteNote({ commentableId: id })
        .then((_) => {
          remove(this.notes.comments, (n) => n.id === id);
        })
        .catch(this.onError())
        .finally(() => this.resetNote());
    },
    deleteTag(tag) {
      this.tag.working = true;
      const tagsBackup = Vue.util.extend([], this.tags);
      remove(this.tags, (t) => t.text === tag);
      this.updateTags({
        taggableId: this.macId,
        list: this.tags.map((t) => t.text),
      })
        .catch((error) => {
          this.tags = tagsBackup;
          this.$message({
            showClose: true,
            message: error,
            type: "error",
          });
        })
        .finally(() => (this.tag.working = false));
    },
    addTag() {
      this.tag.working = true;
      this.tags.push({ text: this.tag.text });
      this.updateTags({
        taggableId: this.macId,
        list: this.tags.map((t) => t.text),
      })
        .catch((error) => {
          this.tags.pop();
          this.$message({
            showClose: true,
            message: error,
            type: "error",
          });
        })
        .finally(() => this.resetTag());
    },
    onError(msg) {
      return (err) => {
        const message = msg || err;
        this.$message({
          showClose: true,
          message,
          type: "error",
        });
      };
    },
  },
};
</script>

<style lang="scss">
.new-note-text__textarea {
  margin: 24px 16px;
}
.device-notes-tags {
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  .note {
    p {
      color: transparentize($--color-milano-red, 0.2);
    }
    .foot-note {
      div {
        color: $--color-dusty-gray;
      }
      i {
        cursor: pointer;
      }
    }
    .add-btn {
      margin: 18px 0;
    }
  }
  .tags {
    span.el-tag {
      margin-right: 7px;
      margin-bottom: 7px;
      height: 44px;
      border-radius: 20px;
      padding: 7px 10px;
      background: transparentize($--color-matisse, 0.9);
      color: $--color-dusty-gray;
    }
    .add-btn {
      margin: 18px 0;
    }
  }
}
</style>
